import Product from "../pages/platform-pages/dealer/product";
import Cart from "../pages/platform-pages/dealer/cart";
import SysUser from "../pages/platform-pages/admin/sys-user";
import {PlatformType} from "../utils/constants";
import DealerHome from "../pages/platform-pages/dealer/home";
import Index from "../pages/platform-pages/dealer/index";
import Bulletin from "../pages/bulletin";
import QualificationReport from "../pages/qualification-report";

const route: Route = {
    '/sys/bulletin':{
        component: Bulletin
    },
    '/product': {
        component: Product
    },
    '/qualification/': {
        component: QualificationReport
    },
    '/cart': {
        component: Cart
    },
    '/sys/user': {
        component: () => SysUser({platform: PlatformType.Dealer})
    },
    '/company/home': {
        component: DealerHome
    },
    '/index':{
        component: Index
    }
}
export default route;
